import { render } from "./InstitutionsTab.vue?vue&type=template&id=497bae48"
import script from "./InstitutionsTab.vue?vue&type=script&lang=js"
export * from "./InstitutionsTab.vue?vue&type=script&lang=js"

import "./InstitutionsTab.vue?vue&type=style&index=0&id=497bae48&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__